import React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { Divider, Stack, Typography } from '@mui/material';
import { MonthlyCostIcon, OneOffCostIcon, PayTodayIcon } from '../shared/CustomIcons.styled';
import styles from './style';
import priceFormatter from '../../../util/priceFormatter';

const EirOrderSummaryBreakdown = ({ summaryData, cartData }) => {
  const theme = useTheme();
  return (
    <Paper sx={styles(theme).summaryCard}>
      <Box sx={styles(theme).summaryContainer}>
        <Typography variant='h2' sx={styles(theme).cartTitle}>
          {summaryData?.summary?.title?.breakdownTitle}
        </Typography>
        <Stack
          direction='row'
          justifyContent='space-between'
          alignItems='flex-start'
          sx={styles(theme).summaryItem}
        >
          <Stack direction='row'>
            <MonthlyCostIcon sx={{ margin: '0.3rem auto' }} />

            <Stack direction='column' justifyContent='space-between' alignItems='flex-start'>
              <Typography
                component='p'
                variant='subtitle1'
                sx={{ color: theme.palette.primary.textColor3 }}
              >
                {summaryData?.summary?.monthlyText?.title}
              </Typography>
              <Typography variant='body2' sx={styles(theme).subText}>
                {summaryData?.summary?.monthlyText?.subtitle}
              </Typography>
            </Stack>
          </Stack>

          <Stack direction='row' justifyContent='space-between' alignItems='center' spacing={2}>
            <Typography variant='body1' sx={styles(theme).monthlyCostTotal}>
              {priceFormatter(parseFloat(cartData.monthlyTotal))}
            </Typography>
          </Stack>
        </Stack>

        {cartData?.discountedOnceOffPrice > 0 && (
          <>
            <Divider />
            <Stack
              direction='row'
              justifyContent='space-between'
              alignItems='flex-start'
              sx={styles(theme).summaryItem}
            >
              <Stack direction='row'>
                <OneOffCostIcon sx={{ margin: '0.3rem auto' }} />

                <Stack direction='column' justifyContent='space-between' alignItems='flex-start'>
                  <Typography
                    component='p'
                    variant='subtitle1'
                    sx={{ color: theme.palette.primary.textColor3 }}
                  >
                    {summaryData?.summary?.onceOffText.title}
                  </Typography>
                  <Typography variant='body2' sx={styles(theme).subText}>
                    {summaryData?.summary?.onceOffText.subtitle}
                  </Typography>
                </Stack>
              </Stack>

              <Stack direction='row' justifyContent='space-between' alignItems='center' spacing={2}>
                <Typography component='p' sx={styles(theme).onceOffCost}>
                  {priceFormatter(parseFloat(cartData.discountedOnceOffPrice))}
                </Typography>
              </Stack>
            </Stack>
          </>
        )}
        {cartData?.payTodayTotal > 0 && !cartData?.hasUpfrontCostItem && (
          <>
            <Divider />
            <Stack
              direction='row'
              justifyContent='space-between'
              alignItems='flex-start'
              sx={styles(theme).summaryItem}
            >
              <Stack direction='row'>
                <OneOffCostIcon sx={{ margin: '0.3rem auto' }} />

                <Stack direction='column' justifyContent='space-between' alignItems='flex-start'>
                  <Typography
                    component='p'
                    variant='subtitle1'
                    sx={{ color: theme.palette.primary.textColor3 }}
                  >
                    {summaryData?.summary?.upfrontText.title}
                  </Typography>
                </Stack>
              </Stack>

              <Stack direction='row' justifyContent='space-between' alignItems='center' spacing={2}>
                <Typography component='p' sx={styles(theme).onceOffCost}>
                  {priceFormatter(parseFloat(cartData.payTodayTotal))}
                </Typography>
              </Stack>
            </Stack>
          </>
        )}
        {cartData?.hasUpfrontCostItem && (
          <>
            <Divider />
            <Stack
              direction='row'
              justifyContent='space-between'
              alignItems='flex-start'
              sx={styles(theme).summaryItem}
            >
              <Stack direction='row'>
                <PayTodayIcon sx={{ margin: '0.3rem auto' }} />

                <Stack direction='column' justifyContent='space-between' alignItems='flex-start'>
                  <Typography
                    component='p'
                    variant='subtitle1'
                    sx={{ color: theme.palette.primary.textColor3 }}
                  >
                    {summaryData?.summary?.payTodayText.title}
                  </Typography>
                  {cartData.hasMBBOffer === false &&
                    cartData.hasBillPayPlans === true &&
                    cartData.hasUpfrontSIMOPlans === false && (
                      <Typography variant='body2' sx={styles(theme).subText}>
                        {summaryData?.summary?.payTodayText.subtitle}
                      </Typography>
                    )}
                  {cartData.hasMBBOffer === false &&
                    cartData.hasBillPayPlans === true &&
                    cartData.hasUpfrontSIMOPlans === true && (
                      <Typography variant='body2' sx={styles(theme).subText}>
                        {summaryData?.summary?.payTodayText.simoBillPaySubTitle}
                      </Typography>
                    )}
                  {cartData.hasMBBOffer === true &&
                    cartData.hasBillPayPlans === false &&
                    cartData.hasUpfrontSIMOPlans === false && (
                      <Typography variant='body2' sx={styles(theme).subText}>
                        {summaryData?.summary?.payTodayText.mbbSubtitle}
                      </Typography>
                    )}
                  {cartData.hasMBBOffer === true &&
                    cartData.hasBillPayPlans === true &&
                    cartData.hasUpfrontSIMOPlans === false && (
                      <Typography variant='body2' sx={styles(theme).subText}>
                        {summaryData?.summary?.payTodayText.mbbMobileBillPaySubTitle}
                      </Typography>
                    )}
                  {cartData.hasMBBOffer === true &&
                    cartData.hasBillPayPlans === false &&
                    cartData.hasUpfrontSIMOPlans === true && (
                      <Typography variant='body2' sx={styles(theme).subText}>
                        {summaryData?.summary?.payTodayText.mbbMobileSIMOSubTitle}
                      </Typography>
                    )}
                  {cartData.hasMBBOffer === true &&
                    cartData.hasBillPayPlans === true &&
                    cartData.hasUpfrontSIMOPlans === true && (
                      <Typography variant='body2' sx={styles(theme).subText}>
                        {summaryData?.summary?.payTodayText.mbbBillPaySIMOSubTitle}
                      </Typography>
                    )}
                </Stack>
              </Stack>

              <Stack direction='row' justifyContent='space-between' alignItems='center' spacing={2}>
                <Typography variant='subtitle1' sx={styles(theme).totalPrice}>
                  {priceFormatter(parseFloat(cartData.payTodayTotal))}
                </Typography>
              </Stack>
            </Stack>
          </>
        )}
      </Box>
    </Paper>
  );
};
export default EirOrderSummaryBreakdown;
